import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import serviceCodeFormMeta, { IServiceCodeFormMeta } from "../../../../cardProduct/formMeta/magneticTapeApplication/serviceCodeFormMeta";
import internetMailOrderFormMeta, { I_InternetMailOrderFormMeta } from "../../../../cardProduct/formMeta/magneticTapeApplication/internetMailOrderFormMeta";
import prepaidDataFormMeta, { IPrepaidDataFormMeta } from "./prepaidDataFormMeta";

export interface IAdditionalMainDataFormMeta {
    firstCreationDate: FormInputMeta;
    lastCustomizableDate: FormInputMeta;
    lastCustomizableBatch: FormInputMeta;
    lastTransactionDate: FormInputMeta;
    pinMethod: FormInputMeta;

}

export interface IAdditionalDataFormMeta extends IAdditionalMainDataFormMeta, IServiceCodeFormMeta, I_InternetMailOrderFormMeta, IPrepaidDataFormMeta {
    
    schema: any;
}

let additionalDataFormMeta = {} as IAdditionalDataFormMeta;

const additionalMainDataFormMeta = {} as IAdditionalDataFormMeta;

additionalMainDataFormMeta.firstCreationDate = {
    name: "firstCreationDate",
    type: "date",
    label: "Première Date Création",
    placeholder: "",
    validation: yup.date().notRequired(),
};

additionalMainDataFormMeta.lastCustomizableDate = {
    name: "lastCustomizableDate",
    type: "date",
    label: "Dernière Date Personnalis.",
    placeholder: "",
    validation: yup.date().notRequired(),
};

additionalMainDataFormMeta.lastCustomizableBatch = {
    name: "lastCustomizableBatch",
    type: "text",
    label: "Dernière Batch Personnalis.",
    placeholder: "",
    validation: yup.string(),
};

additionalMainDataFormMeta.lastTransactionDate = {
    name: "lastTransactionDate",
    type: "date",
    label: "Dernière Date Transaction",
    placeholder: "",
    validation: yup.date().notRequired(),
};

additionalMainDataFormMeta.pinMethod = {
    name: "pinMethod",
    type: "text",
    label: "Méthode Pin",
    placeholder: "",
    validation: yup.string(),
};

additionalDataFormMeta = {...additionalMainDataFormMeta, ...serviceCodeFormMeta, ...prepaidDataFormMeta, ...internetMailOrderFormMeta}

additionalDataFormMeta.schema = yup.object().shape(getValidationSchema(additionalDataFormMeta));

export default additionalDataFormMeta;

export type TAdditionalData = {
    additionalDataFormMeta: IAdditionalDataFormMeta;
    additionalMainDataFormMeta:IAdditionalMainDataFormMeta;
    internetMailOrderFormMeta: I_InternetMailOrderFormMeta;
    serviceCodeFormMeta: IServiceCodeFormMeta;
    prepaidDataFormMeta: IPrepaidDataFormMeta;
}

export const additionalDataFormMetaObj: TAdditionalData = {additionalDataFormMeta, additionalMainDataFormMeta, internetMailOrderFormMeta, serviceCodeFormMeta, prepaidDataFormMeta}